import { render } from "./EmployeeJobAssigns.vue?vue&type=template&id=fe07bbec"
import script from "./EmployeeJobAssigns.vue?vue&type=script&lang=js"
export * from "./EmployeeJobAssigns.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__